import { SVG } from './SVG';
const IconFilter = ({ width = 14, height = 12, color = '#4062BB' }) => {
  return (
    <SVG width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="2" y1="1" x2="2" y2="11" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="7" y1="1" x2="7" y2="11" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="12" y1="1" x2="12" y2="11" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="2" cy="4" r="1.5" fill={color} />
      <circle cx="7" cy="8" r="1.5" fill={color} />
      <circle cx="12" cy="4" r="1.5" fill={color} />
    </SVG>
  );
};
export { IconFilter as default, IconFilter };
